import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
// services
import { AuthService } from '@auth/auth.service';
import { LoaderService } from './services/loader/loader.service';
// utilities
import { NumberOnlyDirective } from './utility/number-only.directive';
import { ReplaceAccountPipe } from './utility/replace-account.pipe';
import { SortByPipe } from './utility/sort-by-pipe';
// components
// Declared here, not in either account module: both of them render it.
import { AccountComponent } from '@account/account.component';
import { HeaderLoggedOutComponent } from './components/header/header-logged-out.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ModalErrorComponent } from './components/modal-error/modal-error.component';
import { ProgresoComponent } from './components/progress-bar/progreso.component';
import { RedirectionComponent } from './components/redirection/redirection.component';

@NgModule({
  declarations: [
    LoaderComponent,
    SortByPipe,
    ProgresoComponent,
    ReplaceAccountPipe,
    RedirectionComponent,
    NumberOnlyDirective,
    HeaderLoggedOutComponent,
    ModalErrorComponent,
    AccountComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatPaginatorModule,
    MatCardModule,
    MatTableModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatDialogModule,
    MatIconModule,
  ],
  exports: [
    LoaderComponent,
    SortByPipe,
    ReplaceAccountPipe,
    ProgresoComponent,
    RedirectionComponent,
    HeaderLoggedOutComponent,
    ModalErrorComponent,
    AccountComponent,
  ],
  providers: [LoaderService],
  entryComponents: [ModalErrorComponent],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [AuthService],
    };
  }
}
